import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { FlowsService } from "src/app/flows/flows.service";
import { FlowMenuComponent } from "../../flow-menu/flow-menu.component";

@Component({
  selector: "app-notification-node-menu",
  templateUrl: "./notification-node-menu.component.html",
  styleUrls: ["./notification-node-menu.component.scss"],
})
export class NotificationNodeMenuComponent
  extends FlowMenuComponent
  implements OnInit
{
  notifications: any[] = [];
  notificationOptions!: any[];
  frequencyOptions!: any[];

  constructor(private FlowsService: FlowsService) {
    super();
  }

  ngOnInit(): void {
    //console.log('NOTIFICATION NODE MENU INIT')

    this.frequencyOptions = this.FlowsService.getFrequencies('notification');

    if (this.node.data?.notify) {
      for (let notification of this.node.data.notify) {
        this.notifications.push({
          uuid: Math.random().toString(16).slice(2, 8),
          formGroup: new FormGroup({
            notificationGroup: new FormControl(
              notification.field,
              Validators.required,
            ),
            frequency: new FormControl(
              notification.frequency,
              Validators.required,
            ),
          }),
        });
      }
    }

    this.notificationOptions = this.FlowsService.notificationOptions;
  }

  get invalid() {
    let formValid = true;
    this.notifications?.forEach((notification) => {
      if (notification.formGroup.invalid) {
        formValid = false;
      }
    });

    return !formValid;
  }

  get signalFilters() {
    return this.frequencyOptions;
  }

  addNotification($event: Event) {
    $event.stopPropagation();

    this.notifications.push({
      uuid: Math.random().toString(16).slice(2, 8),
      formGroup: new FormGroup({
        notificationGroup: new FormControl(null, Validators.required),
        frequency: new FormControl(null, Validators.required),
      }),
    });
  }

  removeNotification(notification: any) {
    this.notifications = this.notifications.filter((noti) => {
      return noti.uuid !== notification.uuid;
    });
  }

  get nodeDTO() {
    let index = 0;
    const notifications = this.notifications.map((notification) => {
      const notificationGroup = this.notificationOptions.find((option) => {
        return (
          option.field ===
          notification.formGroup.controls.notificationGroup.value
        );
      });
      const notificationDTO = {
        field: notificationGroup.field,
        id: index,
        label: notificationGroup.label,
        type: notificationGroup.type,
        frequency: notification.formGroup.controls.frequency.value,
      };

      index++;

      return notificationDTO;
    });

    return {
      id: this.node.id,
      type: "notification",
      top: this.node.top,
      left: this.node.left,

      data: {
        type: "notification",
        notify: notifications ?? [],
      },
    };
  }
}
